import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Speed up Google Fonts fetch by opening the connection as early as possible.
if (typeof document !== 'undefined') {
  const preconnects: {
    href: string;
    crossOrigin?: string;
  }[] = [{
    href: 'https://fonts.googleapis.com'
  }, {
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous'
  }];
  preconnects.forEach(({
    href,
    crossOrigin
  }) => {
    if (document.querySelector(`link[rel="preconnect"][href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = href;
    if (crossOrigin) link.crossOrigin = crossOrigin;
    document.head.appendChild(link);
  });
}
render(<App data-id="element-284" data-mp="2tyv6n51s4hjc" />, document.getElementById('root'));